import { render } from "./AiReportDetail.vue?vue&type=template&id=5abcebb0&ts=true"
import script from "./AiReportDetail.vue?vue&type=script&lang=ts"
export * from "./AiReportDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__